import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userId: 0,
  userName: '',
  userRole: '',
  userImage: '',
  userEmail: '',
  isAuthed: ''
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // custom user 

    login: (state, action) => {
      state.isAuthed = true
      state.userId = action.payload.id;
      state.userName = action.payload.userName;
      state.userRole = action.payload.userRole;
      state.userEmail = action.payload.email;
      state.userImage = action.payload.userImage;
      localStorage.setItem('username', JSON.stringify(action.payload));
    },

    // api random users
    // login: (state, action) => {
    //   state.isAuthed = true
    //   state.userName = action.payload.name.first;
    //   state.userRole = action.payload.userRole;
    //   state.userEmail = action.payload.email;
    //   state.userImage = action.payload.picture.medium;
    //   localStorage.setItem('username', JSON.stringify(action.payload));
    // },
    logout: (state,) => {
      state.isAuthed = false
      state.userId = '';
      state.userName = '';
      state.userRole = '';
      state.userEmail = '';
      state.userImage = '';
      localStorage.removeItem('username');
      // localStorage.removeItem('peshbiniakan');
      
    }
  }
});

export const { login, logout } = userSlice.actions

export default userSlice.reducer